import { compose } from 'redux';
import { connect } from 'react-redux';

import routeDependencies from 'utilities/routeDependencies';
import { loadable } from 'modules/layout';
import { sortable } from 'modules/sortable';

import InfoCategory, { infoCategoryShape } from '../../components/InfoCategory';

import { infoCategoriesRequest, updateInfoCategoryOrder } from '../../services/actions';
import { selectInfoCategories, selectInfoCategoriesListPending } from '../../services/selectors';

export default compose(
    connect(
        state => ({
            initialItems: selectInfoCategories(state),
            showLoader: selectInfoCategoriesListPending(state),
        }),
        dispatch => ({
            read: () => {
                dispatch(infoCategoriesRequest());
            },
            onSortEnd: info => {
                dispatch(updateInfoCategoryOrder(info));
            },
        }),
    ),
    routeDependencies(),
    loadable,
    sortable({
        shape: infoCategoryShape,
        settings: {
            lockAxis: 'y',
            axis: 'y',
        },
    }),
)(InfoCategory);
